import {Component} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';
import {strToObject} from './Util';

@Component({
  selector: 'app-dff-checkbox',
  templateUrl: './dff-checkbox.component.html',
  styleUrls: ['./dff-checkbox.component.scss']
})
export class DffCheckboxComponent extends AbstractDynamicFormFieldDirective {
  value = false;

  validate(value: string): string[] {
    if (this.field.isRequired && !this.value) {
      return ['validate_required'];
    }
    return [];
  }

  writeValue(value: string) {
    this.value = strToObject<boolean>(value);
  }

}

